module.exports = __webpack_public_path__ + "static/media/Alba soffa divan 210_3 FS tyg Vogue Winter Moss 11 miljö 2024 ny fyrkant.70226be9.jpg";